import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;

  flex-direction: column;
  justify-content: center;

  background-color: var(--background);
`;

export const Header = styled.div`
  height: 80px;

  background-color: var(--primary);

  display: flex;
  align-items: center;
  justify-content: center;

  h1 {
    color: var(--text);
    font-size: 24px;
  }
`;

export const Form = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;

  align-self: center;

  padding: 10px;

  width: min(720px, 100%);
`;

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
  min-width: 160px;

  > span {
    font-size: 0.75rem;
    font-weight: 600;
    color: var(--primary);
  }
`;

export const ClearFiltersButton = styled.button`
  flex: 0 0 145px;
  width: 145px;
  height: 50px;
  padding: 0 16px;

  background-color: #fff;
  color: var(--primary);
  border: 1px solid var(--primary);
  border-radius: 0.25rem;
  cursor: pointer;

  font-size: 1rem;
  font-weight: 500;
  transition: background-color 0.2s, transform 0.2s;

  &:hover {
    background-color: #f2faf8;
  }

  &:active {
    transform: translateY(1px);
  }

  @media (max-width: 800px) {
    flex: 1;
    width: auto;
  }
`;

export const ActionsBar = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 15px 15px 0;

  @media (max-width: 800px) {
    justify-content: stretch;
  }
`;

export const SelectedLaudosButton = styled.button`
  min-height: 44px;
  padding: 0 18px;
  border: 0;
  border-radius: 8px;
  background: var(--primary);
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  transition: filter 0.2s;

  &:hover {
    filter: brightness(0.92);
  }

  @media (max-width: 800px) {
    width: 100%;
  }
`;

export const List = styled.div`
  padding: 15px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 24px;

  margin-top: 20px;
  margin-bottom: 50px;

  list-style: none;

  width: 100%;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 800px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const Imagem = styled.div`
  width: 55px;
  height: 55px;

  display: flex;

  align-items: center;
  justify-content: center;

  background: var(--background);

  border-radius: 10px;

  margin-right: 5px;
`;

export const Logo = styled.img`
  width: 50px;
  height: 50px;
`;

export const UserInfo = styled.div`
  flex-direction: row;
  align-items: center;
`;
export const User = styled.div``;
export const UserGretting = styled.strong`
  color: var(--secondary);

  font-size: 18px;
  font-weight: normal;
`;

export const HeaderButton = styled.div`
  width: 100px;
  position: absolute;

  right: 0;
`;
export const HeaderPhoneButton = styled.div`
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  button {
    width: 40px;
    height: 40px;
    border: 1px solid white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  position: absolute;

  right: 100px;
`;

export const LaudoNoContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  p {
    color: var(--primary);
    font-size: 18px;
  }
`;
